(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('GimnasioDeleteController',GimnasioDeleteController);

    GimnasioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gimnasio'];

    function GimnasioDeleteController($uibModalInstance, entity, Gimnasio) {
        var vm = this;

        vm.gimnasio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Gimnasio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
